import Helper from '@ember/component/helper';
import { service } from '@ember/service';

export default class ZendeskHelper extends Helper {
  @service zendeskLocalization;

  compute() {
    return this.zendeskLocalization.localization;
  }
}
